// Formats a researcher name part: adds a full stop if the part is a single character
export function formatResearcherNamePart(name) {
  if (typeof name !== 'string') return name;
  name = name.trim();
  return name.length === 1 ? name + '.' : name;
}

// Formats a full researcher name (first + last)
export function formatResearcherNames(first, last) {
  return [formatResearcherNamePart(first), formatResearcherNamePart(last)]
    .filter(Boolean)
    .join(' ');
}

export function formatResearcherFullName(fullName) {
  if (typeof fullName !== 'string') return fullName;
  return fullName
    .split(' ')
    .map(formatResearcherNamePart)
    .join(' ');
}
